import { News } from '../components/News';

export function NewsPage() {
    return (
        <div className="min-h-screen">
            {/* News Section */}
            <div className="pt-20">
                <News />
            </div>
        </div>
    );
}
